export default __webpack_public_path__ + "static/media/primecarephysio.7943c9ac.jpg";